import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { LocationGroupRepository } from '../../repositories/location-group.repository';
import { BaseResponse } from 'planning-portal-library/src/lib/data/shared/base.response';
import { CreateLocationGroupsForAMSRequest } from '../../domain/requests/location-group/create-location-groups-for-ams-request';


@Injectable({ providedIn: 'root' })
export class CreateLocationsGroupsByAMSUseCase implements UseCase<CreateLocationGroupsForAMSRequest, BaseResponse<string>> {
  constructor(private readonly locationGroupRepository: LocationGroupRepository) {}

  execute(params: CreateLocationGroupsForAMSRequest): Observable<BaseResponse<string>> {
    return this.locationGroupRepository.CreateLocationsGroupsByAMS(params);
  }
}
